import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import BasicModal from '@app/components/Modal/BasicModal';
import { modalClose } from '@app/store/modal/actions';

interface ContractProgressConfirmWithInformationLinkModalProps {
  alertType: string;
}

interface ModalData {
  closeText: string;
  content: string;
  title: string;
  url: string;
}

export default function ContractProgressConfirmWithInformationLinkModal({
  alertType,
}: ContractProgressConfirmWithInformationLinkModalProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const alertModalSet: Record<string, ModalData> = {
    extension: {
      closeText: t('ContractProgressConfirmWithInformationLinkModal-extensionErrorCloseText'),
      content: t('ContractProgressConfirmWithInformationLinkModal-extensionErrorContent'),
      title: t('ContractProgressConfirmWithInformationLinkModal-extensionErrorTitle'),
      url: 'https://support.modusign.co.kr/hc/ko/articles/360012992914',
    },
    size: {
      closeText: t('ContractProgressConfirmWithInformationLinkModal-sizeErrorCloseText'),
      content: t('ContractProgressConfirmWithInformationLinkModal-sizeErrorContent'),
      title: t('ContractProgressConfirmWithInformationLinkModal-sizeErrorTitle'),
      url: 'https://support.modusign.co.kr/hc/ko/articles/360011662414',
    },
  };
  const alertModal = alertModalSet[alertType];

  const handleLinkOpen = () => {
    if (alertModal) {
      const openedWindow = window.open();
      if (!openedWindow) {
        return;
      }

      openedWindow.location.href = alertModal.url;
      openedWindow.opener = null;
    }
  };

  const { closeText, title, content } = alertModal;
  return (
    <BasicModal
      cancelText={t('Global-close')}
      closeText={closeText}
      content={content}
      title={title}
      onCancel={() => dispatch(modalClose())}
      onClose={handleLinkOpen}
    />
  );
}
